import { UI_NAME } from './tabs.constants';

export const CLASS_NAMES = {
  root: UI_NAME,
  item: `${UI_NAME}__item`,
  'item--active': `${UI_NAME}__item--active`
};
